import React from 'react';
import Input from '../Common/Input';
import InputMask from 'react-input-mask';
import Select from '../Common/Select';

import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

const Form = ({ formik }) => {



    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>تاریخ انقضا</label>
           {/*              <InputMask
                            mask="9999/99/99"
                            className="form-control ltr-input"
                            value={formik.values.expireDate}
                            onChange={e => formik.setFieldValue('expireDate', e.target.value)} /> */}

                        <DatePicker
                            name="p_todate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={formik.values.expireDate}
                            onChange={(value) => formik.setFieldValue('expireDate', value)}
                            className="form-control"
                            inputPlaceholder='  تاریخ را انتخاب کنید ...'
                        />

                    </div>
                </div>
                <div className="col-md-2">
                    <Select label="وضعیت" name="isActive" required={true} formik={formik} value={formik.values.isActive}>
                        <option value="1">فعال</option>
                        <option value="0">غیرفعال</option>
                    </Select>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label>محتوا</label>
                        <textarea rows="4" className="form-control" value={formik.values.content} onChange={e => formik.setFieldValue('content', e.target.value)}></textarea>
                    </div>
                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;